import { render, staticRenderFns } from "./ExportVoorwaarden.vue?vue&type=template&id=02ed889c&"
import script from "./ExportVoorwaarden.vue?vue&type=script&lang=js&"
export * from "./ExportVoorwaarden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports